var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCpuIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 8a.5.5 0 000-1H13V6h1.5a.5.5 0 000-1H13V3.5l-.5-.5H11V1.5a.5.5 0 00-1 0V3H9V1.5a.5.5 0 00-1 0V3H7V1.5a.5.5 0 00-1 0V3H5V1.5a.5.5 0 00-1 0V3H2.5l-.5.5V5H.5a.5.5 0 000 1H2v1H.5a.5.5 0 000 1H2v1H.5a.5.5 0 000 1H2v1H.5a.5.5 0 000 1H2v1.5l.5.5H4v1.5a.5.5 0 001 0V14h1v1.5a.5.5 0 001 0V14h1v1.5a.5.5 0 001 0V14h1v1.5a.5.5 0 001 0V14h1.5l.5-.5V12h1.5a.5.5 0 000-1H13v-1h1.5a.5.5 0 000-1H13V8h1.5zM9 10H6V7h3v3z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCpuIcon);
export default __webpack_public_path__ + "static/media/cpu-icon.8d0c2b70fe27dedeec7173229a094380.svg";
export { ForwardRef as ReactComponent };